export const EXPIRATION_60_DAYS_IN_SECONDS = 60 * 60 * 24 * 60;
export const BLACK_FRIDAY_COOKIE_NAME = 'black_friday_2025_message_seen';
